// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"3d3003d0","453":"60ad4560"}[chunkId] + ".chunk.js";
};